import { TECH_CAPABILITIES, ENTERPRISE_FEATURES } from "../../data/content";

export default function TechSection() {
  return (
    <section className="py-24 lg:py-32 border-t border-white/5 bg-navy-900/50" data-testid="tech-section">
      <div className="container-x">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-14">
          <div>
            <p className="section-label">TECHNOLOGY</p>
            <h2 className="mt-5 font-heading text-4xl sm:text-5xl font-bold tracking-tight text-white">
              MODERN DEVELOPMENT.<br /><span className="text-flame">REAL ENGINEERING.</span>
            </h2>
            <p className="mt-6 text-slate-400 leading-relaxed max-w-lg">
              We combine experienced software engineering, product thinking and AI-assisted/vibe-coding workflows to
              accelerate application development. Technology is the enabler — your business outcome is the product.
            </p>
            <div className="mt-8 flex flex-wrap gap-2.5">
              {TECH_CAPABILITIES.map((t) => (
                <span key={t} className="rounded-full border border-white/10 bg-navy-800 px-4 py-2 text-xs font-medium text-slate-300">
                  {t}
                </span>
              ))}
            </div>
          </div>
          <div className="rounded-2xl border border-white/10 bg-navy-800 p-8 sm:p-10">
            <p className="font-mono text-[11px] tracking-[0.25em] text-slate-500 mb-6">BUILT FOR REAL BUSINESS REQUIREMENTS</p>
            <div className="grid grid-cols-2 gap-x-6 gap-y-3.5">
              {ENTERPRISE_FEATURES.map((f) => (
                <p key={f} className="flex items-center gap-2.5 text-xs text-slate-300">
                  <span className="w-1 h-1 rounded-full bg-flame shrink-0" /> {f}
                </p>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
